import * as turfHelpers from "@turf/helpers";
import moment from "moment-timezone";
import { createRiskEvaluator } from "@/views/enterprise/live-map/layers/radar-grid/utils/riskEvaluator";
import { isTracked, toJST } from "./RadarGridObjectUtil";
import { WakeLineUtil } from "@/utils";

export function createRadarGridGeoJson(radarGridObjects) {
  let features = [];
  radarGridObjects.forEach(obj => {
    const props = normalizeRadarObjectProperties(obj);
    const feature = turfHelpers.point([props.log, props.lat], props);
    features.push(feature);
  });
  return turfHelpers.featureCollection(features);
}

export function normalizeRadarObjectProperties(obj) {
  const risk = createRiskEvaluator(obj);

  const props = {
    textColor: risk.color,
    log: parseFloat(obj.c.lon),
    lat: parseFloat(obj.c.lat),
    sog: obj.sog,
    cog: obj.cog,
    objectIcon: risk.objectIcon,
    trackNumber: `${obj.n}`,
    trackNumberN: isTracked(obj.k) ? `Track\n${obj.n}` : `Target\n${obj.n}`,
    k: obj.k,
    id: obj.id,
    frameIcon: risk.frameIcon,
    riskLevel: obj.r,
    man_r: obj.man_r,
    ai_r: obj.ai_r,
  };

  if (obj.p.length !== 0) {
    const cam = obj.p[0];
    props.cameraId = cam.ci;
    props.confidence = cam.co ? `${Math.floor(cam.co * 100)}` : "---";
    props.imgUrl = cam.p;
    props.shootingDate = cam.t ? toJST(cam.t, obj.n) : "---";
  }

  return props;
}

export function createPathFeatures(id, wayPoints) {
  const features = wayPoints.reduce((acc, _val, index, self) => {
    if (index === 0) return acc;

    const coordinates = [
      [self[index - 1].lon, self[index - 1].lat],
      [self[index].lon, self[index].lat],
    ];

    const color = WakeLineUtil.getVelocityColor(self[index - 1].v);

    acc.push(
      turfHelpers.lineString(coordinates, {
        objectId: id,
        color: color,
        opacity: 0.9,
        startTime: moment
          .utc(self[index - 1].d)
          .local()
          .format("YYYY/MM/DD HH:mm"),
        endTime: moment
          .utc(self[index].d)
          .local()
          .format("YYYY/MM/DD HH:mm"),
      })
    );

    return acc;
  }, []);
  return features;
}

export default {
  createRadarGridGeoJson,
  normalizeRadarObjectProperties,
  createPathFeatures,
};
